var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '../../lib/dom';
import { BlueButton, OrangeButton } from '../../lib/components/Button/Button';
import { t, PHRASES } from '../../translate';
import { emitter } from '../../app';
import './Confirm.less';
var Confirm = /** @class */ (function (_super) {
    __extends(Confirm, _super);
    function Confirm(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'Confirm';
        _this.needRedraw = false;
        _this.el = _this.DIV("& ".concat(_this.props.className || ''), _this.getContent());
        emitter.on('lang', function () {
            if (_this.visible()) {
                _this.reDraw();
            }
            else {
                _this.needRedraw = true;
            }
        });
        return _this;
    }
    Confirm.prototype.getContent = function () {
        var _this = this;
        var _a = this.props, message = _a.message, okBtnText = _a.okBtnText, cancelBtnText = _a.cancelBtnText, errorMessage = _a.errorMessage, cancelBtnVisible = _a.cancelBtnVisible, closeBtnVisible = _a.closeBtnVisible;
        return [
            this.DIV('&__window', [
                closeBtnVisible ? this.DIV({ className: '&__closeBtn', onClick: function () { return _this.onClick(false); } }) : null,
                this.DIV('&__window-content', [
                    this.DIV('&__text', [message ? message() : t(PHRASES.Something_went_wrong)]),
                    this.DIV('&__error', [errorMessage ? errorMessage() : t(PHRASES.Something_went_wrong)]),
                    this.DIV('&__buttons', [
                        cancelBtnVisible == true || cancelBtnVisible === undefined
                            ? new BlueButton({ className: this.parseClassName('&__cancelBtn'), onClick: function () { return _this.onClick(false); } }, [
                                cancelBtnText ? cancelBtnText() : t(PHRASES.Cancel),
                            ])
                            : null,
                        (this.okBtn = new OrangeButton({ className: this.parseClassName('&__okBtn'), onClick: function () { return _this.onClick(true); } }, [okBtnText ? okBtnText() : 'ok'])),
                    ]),
                ]),
            ]),
        ];
    };
    Confirm.prototype.show = function () {
        if (this.needRedraw) {
            this.reDraw();
            this.needRedraw = false;
        }
        this.toggleErrorMessage(false);
        this.toggle(true);
    };
    Confirm.prototype.hide = function () {
        this.toggle(false);
    };
    Confirm.prototype.onClick = function (ok) {
        this.props.onClick(ok);
    };
    Confirm.prototype.toggle = function (toggle) {
        this.toggleClassName('&_visible', toggle);
    };
    Confirm.prototype.toggleAjaxLoader = function (toggle) {
        this.okBtn.toggleAjaxLoader(toggle);
    };
    Confirm.prototype.toggleErrorMessage = function (toggle) {
        this.toggleClassName('&_error', toggle);
    };
    Confirm.prototype.reDraw = function () {
        ;
        this.el.appendChild(this.getContent(), true);
    };
    Confirm.prototype.visible = function () {
        return this.hasClassName('&_visible');
    };
    return Confirm;
}(Component));
export { Confirm };
